import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixEcomCheckoutContentSpiHostV1CheckoutContentSpiHostServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'bo._base_domain_': [
      {
        srcPath: '/ecom/v1/checkout-content',
        destPath: '/v1/checkout-content',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/ecom/v1/checkout-content',
        destPath: '/v1/checkout-content',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/ecom/v1/checkout-content',
        destPath: '/v1/checkout-content',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/ecom/v1/checkout-content',
        destPath: '/v1/checkout-content',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/ecom/v1/checkout-content',
        destPath: '/v1/checkout-content',
      },
    ],
    _: [
      {
        srcPath: '/ecom/v1/checkout-content',
        destPath: '/v1/checkout-content',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/ecom/api/v1/checkout-content',
        destPath: '/v1/checkout-content',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_ecom_checkout-content';

/** Retrieves a CheckoutContent. */
export function getCheckoutContent(
  payload: object
): RequestOptionsFactory<any> {
  function __getCheckoutContent({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.ecom.api.v1.checkout_content_provider',
      method: 'GET' as any,
      methodFqn:
        'wix.ecom.checkout_content_spi_host.v1.CheckoutContentSPIHostService.GetCheckoutContent',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEcomCheckoutContentSpiHostV1CheckoutContentSpiHostServiceUrl(
        {
          protoPath: '/v1/checkout-content/{appId}/{componentId}',
          data: payload,
          host,
        }
      ),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getCheckoutContent;
}
